import React from 'react';
import PropTypes from 'prop-types';
import './MobileTitle.css';

const MobileTitle = ({ title }) => (
  <div className="mobile-title">
    <h2>{title}</h2>
  </div>
);

MobileTitle.propTypes = {
  title: PropTypes.string,
};

export default MobileTitle;



// WEBPACK FOOTER //
// ./src/components/MobileTitle/MobileTitle.jsx